import React from 'react';
import { Performance } from '@shopify/performance';

const PerformanceContext = /*#__PURE__*/React.createContext(typeof document === 'undefined' ? null : new Performance());

export { PerformanceContext };
